import styled from 'styled-components';
import { COLOR } from '../../../styles/variables';

export const BoxContent = styled.div`
    overflow: hidden;
    h1,
    h2,
    h3,
    h4,
    h5 {
        &:first-of-type {
            margin-top: 0;
        }
    }
`;

export const BoxButtonWrapper = styled.div`
    text-align: center;
`;

export const BoxButton = styled.div`
    display: inline-flex;
    align-items: center;
    justify-content: center;
    color: ${COLOR.overlayFont};
    background: ${COLOR.overlay};
    padding: 0.3rem 0.6rem;
    margin: 1rem auto 0;
    cursor: pointer;

    svg {
        color: ${COLOR.overlayFont};
        margin-right: 0.5rem;
    }
`;

export const Box = styled.div<{ isOpen: boolean; isCollapsible?: boolean }>`
    background: ${COLOR.contentBox};
    padding: 1.5rem;
    margin: 2rem 0;
    position: relative;

    &:after {
        display: ${({ isOpen }) => (isOpen ? 'none' : 'block')};
        content: '';
        position: absolute;
        right: 0;
        bottom: 0;
        left: 0;
        height: 8rem;
        pointer-events: none;
        // Safari hack: the transparent color needs be the same as the background
        background: linear-gradient(180deg, rgba(244, 244, 244, 0) 0%, ${COLOR.contentBox} 50%);
    }

    p:last-child {
        margin-bottom: 0;
    }

    ${BoxContent} {
        max-height: ${({ isOpen }) => (isOpen ? '100%' : '250px')};
    }

    ${BoxButtonWrapper} {
        display: ${({ isCollapsible }) => (isCollapsible ? 'block' : 'none')};
        position: ${({ isOpen }) => (isOpen ? 'static' : 'absolute')};
        bottom: 1rem;
        left: 0;
        right: 0;
        z-index: 1;
    }
`;
